<template>
    <div>
        <div class="block-container">
            <el-tabs v-model="activeName2" @tab-click="handleClick">
                <el-tab-pane v-if="isShow && (!srcFixed || (srcFixed && srcFlag == dealInqryFlag.value))" label="询盘" name="first">
                    <swb-deal-inqry-voucher-for-select :rowId="dealInqryId" :type="type" :showSelect="showSelect" :toDealInqryVoucher="toDealInqryVoucher" ref="swb_deal_inqry_for_select"></swb-deal-inqry-voucher-for-select>
                </el-tab-pane>
                <el-tab-pane v-if="isShow && (!srcFixed || (srcFixed && srcFlag == priceInqryFlag.value))" label="询价" name="second">
                    <swb-price-inpry-for-select :rowId="priceReplyId" :type="type" :showSelect="showSelect" :filter="priceInpryFilter" :toPriceInqryVoucher="toPriceInqryVoucher" ref="swb_price_inqry_for_select"></swb-price-inpry-for-select>
                </el-tab-pane>
                <el-tab-pane v-if="isShow && (!srcFixed || (srcFixed && srcFlag == bidDocFlag.value))" label="招标" name="third">
                    <swb-call-bid-doc-for-select :rowId="callbidId" :type="type" :showSelect="showSelect" :filter="callBidFilter" :toCallBidDoc="toCallBidDoc" :isAll="true" ref="swb_callBidDoc_select"></swb-call-bid-doc-for-select>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import userApi from '../../api/user'
    import contractApi from '../../api/contract'
    //
    import SwbDealInqryVoucherForSelect from '../InqryVoucher/DealInqryVoucherForSelect'
    Vue.regist(SwbDealInqryVoucherForSelect);
    //
    import SwbPriceInpryForSelect from '../priceInpry/PriceInpryForSelect';
    Vue.regist(SwbPriceInpryForSelect);
    //
    import SwbCallBidDocForSelect from '../callbid/CallBidDocForSelect';
    Vue.regist(SwbCallBidDocForSelect);

    export default {
        name: 'swb-show-source-trace',
        desc: '来源管理',
        props: {
            contractId: {
                type: Number
            },
            toDealInqryVoucherList: {
                type: Function
            },
            toPriceInqryVoucherList: {
                type: Function
            },
            toCallBidDocList: {
                type: Function
            },
            type: {
                type: String
            }
        },
        data: function () {
            return {
                activeName2: 'first',
                dealInqryId: null,
                callbidId: null,
                priceReplyId: null,
                showSelect: false,
                userInfo: {},
                srcFlag: 0,
                srcFixed: false,
                bidDocFlag: {},
                priceInqryFlag: {},
                dealInqryFlag: {},
                isShow: false,
                priceInpryFilter: {},
                callBidFilter: {}
            };
        },
        created: function () {
            this.getCurrentUserInfo();

            this.bidDocFlag = getEnumInfoWith('bizSrcFlag', 'name', 'BidDoc');

            this.priceInqryFlag = getEnumInfoWith('bizSrcFlag', 'name', 'PriceInqry');

            this.dealInqryFlag = getEnumInfoWith('bizSrcFlag', 'name', 'DealInqry');

        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if(result.type == "info") {
                        self.userInfo = result.data;
                        self.getContractInfo();
                    }
                });
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            getContractInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.contractId;
                //
                let theLoad = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let contract = result.data;
                        if(contract != null) {
                            let srcFlag = contract.srcFlag;
                            if(srcFlag == self.bidDocFlag.value) {
                                self.callbidId = contract.srcId;
                                self.activeName2 = "third";
                            } else if(srcFlag == self.priceInqryFlag.value) {
                                self.priceReplyId = contract.srcWinId;
                                self.activeName2 = "second";
                            } else if(srcFlag == self.dealInqryFlag.value) {
                                self.dealInqryId = contract.srcId;
                                self.activeName2 = "first";
                            }
                            let srcFixed = contract.srcFixed || false;
                            //
                            self.srcFixed = srcFixed;
                            self.srcFlag = srcFlag;
                            if(srcFixed) {
                                self.showSelect = false;
                            } else {
                                self.showSelect = true;
                            }
                            //
                            let priceInpryFilter = {};
                            priceInpryFilter.inqryMerchantId = contract.fstPartyId;
                            priceInpryFilter.inqryMerchantType = contract.fstPartyType;
                            priceInpryFilter.merchantId = contract.sndPartyId;
                            priceInpryFilter.merchantType = contract.sndPartyType;
                            self.priceInpryFilter = priceInpryFilter;
                            //
                            let callBidFilter = {};
                            callBidFilter.winMerchantId = contract.sndPartyId;
                            callBidFilter.winMerchantType = contract.sndPartyType;
                            self.callBidFilter = callBidFilter;
                            self.isShow = true;
                        }
                    } else {
                        MsgBox.warning(result.message)
                    }
                });
            },
            toDealInqryVoucher: function (no) {
                this.toDealInqryVoucherList.call(parent, no);
            },
            toPriceInqryVoucher: function (no) {
                this.toPriceInqryVoucherList.call(parent, no);
            },
            toCallBidDoc: function (no) {
                this.toCallBidDocList.call(parent, no);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let returnInfo = null;
                if(self.activeName2 == "first") {
                    returnInfo = self.$refs.swb_deal_inqry_for_select.getDlgResult() || null;
                } else if(self.activeName2 == "second") {
                    returnInfo = self.$refs.swb_price_inqry_for_select.getDlgResult() || null;
                } else {
                    returnInfo = self.$refs.swb_callBidDoc_select.getDlgResult() || null;
                }
                if(returnInfo != null) {
                    result.type = 'info';
                    result.data = returnInfo;
                }
                return result;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/compo/contract/ShowSourceTrace.vue